import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const solutions = ['Mover clientes del sábado al miércoles sin perderlos', 'Aumentar tu ingreso promedio sin subir el precio base', 'Instalar reglas para que no te cancelen a último momento', 'Organizar tu semana para no vivir explotado'];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-242">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-zinc-900 border border-amber-500/30 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-243">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-600 via-amber-400 to-amber-600" data-id="element-244" />

        <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-8 uppercase" data-id="element-245">
          Este plan <span className="text-amber-500" data-id="element-246">cambia eso.</span>
        </h2>

        <p className="text-xl text-zinc-300 mb-8 font-medium" data-id="element-247">
          Te enseña cómo:
        </p>

        <ul className="space-y-6 mb-12" data-id="element-248">
          {solutions.map((item, index) => <motion.li key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-zinc-950/50 p-4 rounded-xl border border-zinc-800" data-id="element-249">
              <div className="mt-1 bg-amber-500 p-1 rounded-full text-zinc-950 flex-shrink-0" data-id="element-250">
                <Check className="w-5 h-5 font-bold" data-id="element-251" />
              </div>
              <span className="text-lg text-white font-medium" data-id="element-252">{item}</span>
            </motion.li>)}
        </ul>

        <div className="text-center" data-id="element-253">
          <p className="text-xl text-zinc-400 mb-2" data-id="element-254">No es marketing raro.</p>
          <p className="text-2xl md:text-3xl font-heading font-bold text-amber-500 uppercase" data-id="element-255">
            Es orden aplicado a tu realidad.
          </p>
        </div>
      </motion.div>
    </section>;
}